import { api } from './api';

export const organizationService = {
  getAll: () => api.get('/organizations').then((res) => res.data || res),
  getById: (id) => api.get(`/organizations/${id}`).then((res) => res.data || res),
  create: (payload) => api.post('/organizations', payload).then((res) => res.data || res),
  update: (id, payload) =>
    api.put(`/organizations/${id}`, payload).then((res) => res.data || res),
  delete: (id) => api.delete(`/organizations/${id}`),
  /** Bulk upload tab: per-row results (created / skipped / error). */
  bulkImport: (organizations) =>
    api.post('/organizations/bulk', { organizations }, { silent: true }).then((res) => res.data || res),
};
